window.$ = window.jQuery = require('jquery');
import setupCmsBanners from "../cms-banners";
import setupRequestCallback from './forms/modules/request-callback';
import setupSendEnquiry from './forms/modules/send-enquiry';
import vehicleSliders from "./modules/brand-index/vehicle-sliders";
import anchorFix from "./modules/anchor-fix";

setupCmsBanners();
setupRequestCallback();
setupSendEnquiry();
anchorFix();

const offerElements = document.querySelectorAll('.offers');
offerElements.forEach(element => {
    vehicleSliders(element);
})

function hashChange() {
    const hashFragment = decodeURI(window.location.hash) || '',
    regex = /#(carsOffersCarousel|vansOffersCarousel)-(.*)+/,
    matches = hashFragment.match(regex);

    if (!matches) {
        return;
    }

    const carousel = document.getElementById(matches[1]),
        slideIndex = carousel.querySelector('.slick-slide:not(.slick-cloned) .offers__slide-data[data-model="' + matches[2] + '"]').parentElement.parentElement.dataset.slickIndex;

    if (!carousel || !slideIndex) {
        return;
    }

    carousel.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
    });

    if (slideIndex >= 0) {
        $(carousel).slick('slickGoTo', slideIndex);
    }
}

hashChange();

window.addEventListener("hashchange", () => hashChange());

$('.why-choose-us').slick({
    infinite: true,
    swipeToSlide: true,
    arrows: false,
    dots: true,
    autoplay: true,
    autoplaySpeed: 5000,
    slidesToShow: 3,
    slidesToScroll: 3,
    responsive: [
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ]
});

$('.whats-included').slick({
    mobileResponsive: true,
    infinite: true,
    swipeToSlide: true,
    arrows: false,
    dots: false,
    autoplay: true,
    autoplaySpeed: 5000,
    slidesToShow: 3,
    slidesToScroll: 3,
    responsive: [
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true
            }
        }
    ]
});

$('.business-page__carousel').slick();


// WEBPACK FOOTER //
// ./resources/assets/js/fleet-and-business/brand-index.js